export function idToBarcode(int: number): string {
  // AMS.0000.0123
  // AMS.9999.9999
  // AMS.9999.9999.9999
  const parts = Math.max(
    Math.floor(int / 10000),
    2,  // make sure it's always 2 parts.
  );
  let barcode = "";
  let reminder = int;
  for (let i = 0; i < parts; i++) {
    const part = reminder % 1000;
    reminder -= part;
    barcode = `${String(reminder).padStart(4, "0")}.${barcode}`;
  }
  return `AMS.${barcode}`;
}

export const BARCODE_REGEX = /^AMS(\.\d{4}){2,}$/;

export function isBarcode(barcode: string) {
  return BARCODE_REGEX.test(barcode);
}

function barcodeToId(barcode) {
  // AMS.0000.0123
  // AMS.9999.9999
  // AMS.9999.9999.9999
  if (!isBarcode(barcode)) {
    return null;
  }
  const parts = barcode.split(".").splice(1);
  let collected = 0;
  for (let i = 0; i < parts.length; i++) {
    const part = parts[parts.length - i - 1];
    const partNum = Number.parseInt(part);
    const factor = 1000 ** i;
    collected += partNum * factor;
  }
  return collected;
}
